import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import TotalValue from "../data/TotalData.json";
import ClearIcon from "@mui/icons-material/Clear";
import { Button } from "@mui/material";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login.jsx";
import { Listing } from "../PageLayout/Summary/listing.jsx";
import { AllDetails } from "../PageLayout/Summary/AllDetails.jsx";
import ReactPaginate from "react-paginate";
import { FaRedo } from "react-icons/fa";
import ReportGenerate from "../Layout/ReportGenerate.jsx";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function SummaryAll() {
  const [data, setData] = useState(TotalValue);
  const [query, setQuery] = useState("");
  const [module, setmodule] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(10);
  const [segmentType, setSegment] = useState("");
  const filter_by_role = [...new Set(data.map((item) => item.Status))];
  const filter_by_Module = [...new Set(data.map((item) => item.ModuleName))];
  console.log(filter_by_role)

  let filteredData = [];
  const search_parameters = ["Particulars"];

  filteredData = data.filter((obj) => {
    return obj;
  });

  function search(filteredData) {
    return filteredData.filter(
      (item) =>
        item.Status.includes(segmentType) &&
        item.ModuleName.includes(module) &&
        search_parameters.some((parameter) =>
          item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        )
    );
  }

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const reset = () => {
    setCurrentPage(1);
    setQuery("");
    setSegment("");
    setmodule("")
  };
  useEffect(()=>{
    console.log("currentData",currentData)
  },currentData)

  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHome" style={{ overflowY: "auto" }}>
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "0rem",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gridGap: "10px",
                    marginTop:"2rem"
                  }}
                >
                  <div className="search-input-cont">
                    <input
                      type="text"
                      className="table-search-input"
                      placeholder="Search by Name"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                    />
                    <div className="search-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <path
                          d="M18.0835 16.3331H17.1619L16.8352 16.0181C17.5643 15.171 18.0972 14.1733 18.3957 13.0963C18.6942 12.0193 18.7509 10.8896 18.5619 9.78806C18.0135 6.54473 15.3069 3.95473 12.0402 3.55806C10.8918 3.41277 9.7253 3.53213 8.63008 3.907C7.53485 4.28187 6.5399 4.90232 5.72135 5.72086C4.9028 6.53941 4.28236 7.53437 3.90749 8.62959C3.53261 9.72481 3.41326 10.8913 3.55855 12.0397C3.95521 15.3064 6.54521 18.0131 9.78855 18.5614C10.8901 18.7505 12.0197 18.6937 13.0968 18.3952C14.1738 18.0967 15.1715 17.5638 16.0185 16.8347L16.3335 17.1614V18.0831L21.2919 23.0414C21.7702 23.5197 22.5519 23.5197 23.0302 23.0414C23.5085 22.5631 23.5085 21.7814 23.0302 21.3031L18.0835 16.3331ZM11.0835 16.3331C8.17855 16.3331 5.83355 13.9881 5.83355 11.0831C5.83355 8.17806 8.17855 5.83306 11.0835 5.83306C13.9885 5.83306 16.3335 8.17806 16.3335 11.0831C16.3335 13.9881 13.9885 16.3331 11.0835 16.3331Z"
                          fill="#8D8D8D"
                        />
                      </svg>
                    </div>
                    {query.trim() !== "" && (
                      <ClearIcon
                        className="clear-icon"
                        onClick={() => setQuery("")}
                      />
                    )}
                  </div>

                    <div style={{ display: "flex", gridGap: "20px" }}>

                        <div style={{ display: "flex", gridGap: "20px" }}>
                            <div className="selectParent select">
                            <select
                                className="custom-select"
                                aria-label="Filter by user group"
                                value={segmentType}
                                onChange={(e) => {
                                setSegment(e.target.value);
                                handlePageChange({ selected: 1 });
                                }}
                            >
                                <option value="">Filter by Status</option>
                                {filter_by_role.map((item, index) => (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                                ))}
                            </select>
                            <span className="focus"></span>
                            </div>

                        
                        </div>

                        <div style={{ display: "flex", gridGap: "20px", }}>
                            <div className="selectParent select">
                            <select
                                className="custom-select"
                                aria-label="Filter by user group"
                                value={module}
                                onChange={(e) => {
                                setmodule(e.target.value);
                                handlePageChange({ selected: 1 });
                                }}
                            >
                                <option value="">Filter by Module</option>
                                {filter_by_Module.map((item, index) => (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                                ))}
                            </select>
                            <span className="focus"></span>
                            </div>

                            <div>
                            <Button
                                title="Reset all filters"
                                style={{
                                borderRadius: "6px",
                                textTransform: "capitalize",
                                fontSize: "16px",
                                display: "flex",
                                gridGap: "10px",
                                alignContent: "center",
                                alignItems: "center",
                                background: "#0000a0",
                                padding: "8px",
                                color: "white",
                                fontWeight: "600",
                                width: "auto",
                                height: "48px",
                                }}
                                className="submit_btn"
                                onClick={reset}
                            >
                                <FaRedo />
                            </Button>
                            </div>

                            <div>
                            <ReportGenerate
                        excelData={data}
                        fileName={`Fullreport_${new Date().getTime()}`}
                      />
                            </div>
                        </div>
                        
                  </div>

                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gridGap: "10px",
                      alignContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "18px",
                        paddingBottom: "1rem",
                      }}
                    >
                      Total number of Recommendations{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#253978",
                        }}
                      >
                        {search(filteredData).length}
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gridGap: "10px",
                      alignItems: "center",
                      alignContent: "center",
                    }}
                  >
                    <div>
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handelepageclick}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                      />
                    </div>
                  </div>
                </div>
                <AllDetails dataItem={currentData || []} />
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
